import React from 'react';
import { connect } from 'react-redux';
import {
    Card, CardBlock, CardTitle,
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button
} from 'reactstrap';

import {Link} from 'react-router-dom';

import ReactTable from "react-table";
import "react-table/react-table.css";

import IconPrint from 'react-icons/lib/fa/print';
import IconOpen from 'react-icons/lib/fa/folder-open-o';
import FAplus from 'react-icons/lib/fa/plus';
import FaEdit from 'react-icons/lib/fa/edit';
import IconEdit from 'react-icons/lib/md/edit';


import {API_URL} from '../../actions/_request';
import {api} from '../../actions/_request';
import _ from "lodash";
// styling
import './style.css';
import * as actions from '../../actions/comprasespeciales';
import swal from 'sweetalert2';
import moment from 'moment';
import ModalCompra from "./Modal";

const estados_compra = [
  {label: 'Pendiente', value: 0},
  {label: 'Comprado al Proveedor', value: 1},
  {label: 'En Transito al Storage', value: 2},
  {label: 'En Storage', value: 3},
  {label: 'En Transito a Maxicomm', value: 4},
  {label: 'Recibido En Maxicomm', value: 5},
  {label: 'Cancelado', value: 6},
];
const requestData = (pageSize, page, sorted, filtered) => {    
    return new Promise((resolve, reject) => {
        // You can retrieve your data however you want, in this case, we will just use some local data.
        let filteredData ;
       

        var estado='';
        var cliente='';
        var ticket='';
        var descripcion='';
        var fecha='';

        var take= pageSize;
        var skip=pageSize * page;
        var total=1; 
        var patt = new RegExp("(si|s)", "i"); 
        for (var i = filtered.length - 1; i >= 0; i--) {
          switch(filtered[i].id)
          {
                       
            case "estado":
              patt = new RegExp("("+filtered[i].value+")", "i");
              if('pendiente'.search(patt)==0){
                console.log('estado---> 1');
                estado=1;
              }else{
                  patt = new RegExp("("+filtered[i].value+")", "i");
                  if('Comprando al Proveedor'.search(patt)==0){
                    console.log('estado---> 2');
                    estado=2;
                  }else{
                    patt = new RegExp("("+filtered[i].value+")", "i");
                    if('En Transito al Storage'.search(patt)==0){
                      console.log('estado---> 3');
                      estado=3;
                    }else{
                      patt = new RegExp("("+filtered[i].value+")", "i");
                      if('En Storage'.search(patt)==0){
                        console.log('estado---> 4');
                        estado=4;
                      }else{
                        patt = new RegExp("("+filtered[i].value+")", "i");
                        if('garantia'.search(patt)==0){
                          console.log('estado---> 5');
                          estado=5;
                        }
                      }

                  }
              }
            }

              break;
            case "actualizacion":
              fecha=filtered[i].value;
               console.log('fecha--->',filtered[i].value);
              break;
              case "cliente":
              cliente=filtered[i].value;
              console.log('cliente--->',filtered[i].value);
              break; 
              case "clave":
              ticket=filtered[i].value;
              console.log('clave--->',filtered[i].value);
              break; 
              case "descripcion":
              descripcion=filtered[i].value;
              console.log('descripcion--->',filtered[i].value);
              break;              
          }
        }
              
              api().get(`/compras_especiales?fecha=${fecha}&cliente=${cliente}&ticket=${ticket}&descripcion=${descripcion}&estado=${estado}&take=${take}&skip=${skip}`)
              .then(function(response)
              {
                if(response.status === 200)
                {
                  filteredData= response.data.datos;
                  total= response.data.total; 
                  // You can also use the sorting in your request, but again, you are responsible for applying it.
                  const sortedData = _.orderBy(
                    filteredData,
                    sorted.map(sort => {
                      return row => {
                        if (row[sort.id] === null || row[sort.id] === undefined) {
                          return -Infinity;
                        }
                        return typeof row[sort.id] === "string"
                        ? row[sort.id].toLowerCase()
                        : row[sort.id];
                      };
                    }),
                    sorted.map(d => (d.desc ? "desc" : "asc"))
                  );
                  const res = {
                    rows: sortedData,
                    pages: Math.ceil(total / pageSize)
                  };
                  // Here we'll simulate a server response with 500ms of delay.
                  //setTimeout(() => resolve(res), 1000);
                  //console.log(res);
                  resolve(res)
                }
              });   
        
    });
};

const filterCaseInsensitive = (filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== null){
                return (
                    row[id] !== undefined ?
                        String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
                        :
                        true
                );
            }
        };



class TicketTable extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            modal       : false,
            compra_id : null,
            title       : "",
             data: [],
             pages: null,
             loading: true,
             recargar:false,
        };

        this.toggle = this.toggle.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.editar  = this.editar.bind(this);
        this.recargar2 = this.recargar2.bind(this);
    }

    recargar2(){
        this.setState({
          recargar:true,
      });
    }
    editar(compra){
      let self =this;
     
     console.log('renglon---->',compra)
      swal.queue([{
        title: 'Estas seguro?',
        text: "De Cambiar El Estado al Producto: "+compra.descripcion,
        input: 'select',
        inputOptions :
        {
          0 : 'Pendiente',
          1 : 'Comprado al Proveedor',
          2 : 'En Transito al Storage',
          3 : 'En Storage',
          4 : 'En Transito a Maxicomm',
          5 : 'Recibido En Maxicomm',
          6: 'Cancelado',
        },
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Estoy Seguro!',
        cancelButtonText: 'Cancelar!',
        showLoaderOnConfirm: true,
        preConfirm: (opcion) => {
          return api().post('/compra_especial/'+compra.id,{estado:opcion})
            .then(function(response)
            {    
                   
                if(response.status === 200)
                {   
                   if(response.data.estado){
                    
                    self.setState({
                    recargar : false,
                });

                 
                 self.props.alerta({
                mensaje:"Se Cambio el estado del producto",
                tipo:"success",
                creacion:moment().format('Y-MM-DD H:m:s'),
              });


                   }else{
                    console.log('Mensaje de error--->',response.data.mensaje)
                    swal.insertQueueStep({
                        type: 'error',
                        title: response.data.mensaje
                      })

                   }
                  
                }
            })
            .catch(() => {
              swal.insertQueueStep({
                type: 'error',
                title: 'Solicitar ayuda a un Administrador'
              })
            })
        }
      }]);

    }

    fetchData(state, instance) {
    // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
    // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
    this.setState({ loading: true });
    this.setState({ loading: false });
    // Request the data however you want.  Here, we'll use our mocked service we created earlier
    requestData(
      state.pageSize,
      state.page,
      state.sorted,
      state.filtered
    ).then(res => {
      // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
      this.setState({
        data: res.rows,
        pages: res.pages,
        loading: false
      });
      // console.log('datos--->',res.rows);
       this.props.get(res.rows);
    });
  }

    componentDidMount() {

        let self = this;
        // self.props.get_tickets();
        
    }

    toggle(evt, compra_id = null, title = "Editar Compra Especial") {

        let {modal} = this.state;

        this.setState({
            modal       : !modal,
            compra_id : compra_id,
            title       : title,
        });
    }

    render() {
const { data, pages, loading ,recargar} = this.state;
if(recargar==false)
          setTimeout(this.recargar2() , 3);

    let rol =parseInt( this.props.auth.user.rol);
    let departamento =parseInt( this.props.auth.user.departamento);
    let permisos_modulos= this.props.auth.permisos[7];
      console.log('permisos--->',permisos_modulos);
        return(
            <div className="view">

                <div className="view-header">
                    <header className="title text-white">
                        <h1 className="h4 text-uppercase">Compras Especiales</h1>
                    </header>
                </div>

                <div className="view-content view-components">
                    <Card>
                        <CardBlock>
                             {(recargar==true)&&<ReactTable
                             getTrProps={(state, rowInfo, column) => {
                                 
                                  if(rowInfo === undefined){
                                         
                                          return{

                                          }
                                        }else{
                                           return{
                                            onDoubleClick: (evt)=>this.toggle(evt, rowInfo.original.id, 'Editar Compra Especial')
                                        } 
                                  
                                    }
                              }}
                              
                              
                              className = "-striped -highlight"
                              columns   = {[
                                {Header: 'Fecha', accessor: 'actualizacion',maxWidth:100},
                                {Header: 'Fecha Estimada Arribo', accessor: 'fecha_arribo',maxWidth:130},
                                {Header: 'Estado', accessor: 'estado',
                                Cell: row => (
                                      <span>
                                          {estados_compra[parseInt( row.value)].label}
                                      </span>
                                      )

                              },
                                {Header: 'Descripcion', accessor: 'descripcion'},
                                {Header: 'Ticket.', accessor: 'clave',maxWidth:150},
                                {
                                    Header: 'Controles',
                                    filterable: false,
                                    sortable: false,
                                     maxWidth:80,
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-right">
                                            {parseInt(permisos_modulos.cambios)==1&&

                                            
                                                <Button
                                                 color="success" 
                                                 className="btn-sm" 
                                                 onClick={(evt)=>this.toggle(evt, row.original.id, 'Editar Compra Especial')}>
                                                    <IconEdit />
                                                </Button>
                                                   }
                                                   {' '}
                                            </div>
                                        )
                                    }
                                }
                              ]}
                              manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                              data      = {this.props.comprasespeciales.data}
                              pages={pages} // Display the total number of pages
                              loading={loading} // Display the loading overlay when we need it
                              onFetchData={_.debounce(this.fetchData, 500)} // Request new data when things change
                              filterable
                             
                              defaultPageSize={25} 
                              SubComponent={ row => {
                                          return(
                                              <Card>
                                                  <CardBlock>
                                                      <CardTitle className="h6 text-uppercase mb-4">Datos: </CardTitle>
                                                      <hr/>
                                                          <p><b>Cliente:</b> { row.original.cliente}</p>
                                                          <p><b>Fecha Pedido:</b> { row.original.fecha_pedido} <b>Precio:</b> {row.original.precio_formato}</p>
                                                          
                                                          <p><b>Fecha de Compra:</b> { row.original.fecha_compra}</p>
                                                          <p><b>Nota:</b> {row.original.nota}</p>
                                                       <hr/>
                                                  </CardBlock>
                                              </Card>
                                          )
                                        }}
                             
                              

                            />}
                        </CardBlock>
                    </Card>
                </div>
                {
                   this.state.modal&& 
                   <ModalCompra 
                 open={this.state.modal} 
                 toggle={this.toggle} 
                 title={this.state.title} 
                 compra_id={this.state.compra_id}
                 
                />
                }

            </div>
        );
    }

};

function mapStateToProps(state, ownProps) {
    return {
        comprasespeciales : state.comprasespeciales,
        auth:state.auth,
    }
};

export default connect(mapStateToProps, actions)(TicketTable)





// WEBPACK FOOTER //
// ./src/views/comprasespeciales/table.js